export default __webpack_public_path__ + "static/media/opvs.6e9ab0f9.svg";